import { useState } from "react";
import { useHubAuth } from "@/context/HubAuthContext";
import { formatApiError } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function HubLogin() {
  const { hubLogin } = useHubAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await hubLogin(username, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0f1117] flex items-center justify-center px-6" data-testid="hub-login">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <img src="/logo-dark-256.png" alt="PawLinx" className="h-20 w-auto mx-auto mb-5" data-testid="pawlinx-logo" />
          <p className="font-manrope text-xs text-white/50 tracking-[0.25em] uppercase">Internal Hub</p>
          <p className="font-manrope text-sm text-white/40 mt-2">Team workspace</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-[#1a1d27] border border-white/10 rounded-2xl p-8 space-y-5">
          {error && <p className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-xl px-4 py-2.5 font-manrope" data-testid="hub-login-error">{error}</p>}
          <div className="space-y-1.5">
            <label className="font-manrope text-sm font-medium text-white/60">Username</label>
            <input value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus className="w-full h-11 px-4 rounded-xl bg-white/5 border border-white/10 text-white text-sm font-manrope focus:outline-none focus:border-[#E07A5F] placeholder-white/20" placeholder="Enter username" data-testid="hub-login-username" />
          </div>
          <div className="space-y-1.5">
            <label className="font-manrope text-sm font-medium text-white/60">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full h-11 px-4 rounded-xl bg-white/5 border border-white/10 text-white text-sm font-manrope focus:outline-none focus:border-[#E07A5F] placeholder-white/20" placeholder="Enter password" data-testid="hub-login-password" />
          </div>
          <button type="submit" disabled={loading} className="w-full h-11 bg-[#E07A5F] hover:bg-[#C86347] disabled:opacity-50 text-white rounded-xl font-manrope font-semibold text-sm transition-colors flex items-center justify-center gap-2" data-testid="hub-login-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
